
import React from 'react';
import { Grid, Box, Typography, TextField, MenuItem, Tooltip, } from '@mui/material';

export type InfoFieldType = 'text' | 'number' | 'date' | 'select';

export interface SelectOption {
    _id: string;
    designacao: string;
    // label: string;
    // value: string | number;
}

interface InfoFieldProps {
    nameInput: string;
    label: string;
    value?: any;
    type?: InfoFieldType;
    editable?: boolean | {};
    options?: SelectOption[]; // usado no select
    onChange?: (value: any) => void;
    xs?: number;
    sm?: number;
    variant?: 'body1' | 'body2' | 'caption' | 'h6' | 'subtitle1' | 'subtitle2';
}

const InfoField: React.FC<InfoFieldProps> = ({
    nameInput,
    label,
    value,
    type = 'text',
    editable = false,
    options = [],
    onChange,
    xs = 12,
    sm = 6,
    variant
}) => {

    const renderValue = () => {
        // if (type === 'date' && value) {
        //     return new Date(value).toLocaleDateString();
        // }

        // if (type === 'select') {
        //     return options.find(opt => opt.designacao === value)?.designacao ?? 'Não informado';
        // }

        return value ?? 'Não informado';
    };

    const renderInput = () => {
        if (type === 'select') {
            return (
                <TextField
                    select
                    size="small"
                    fullWidth
                    defaultValue={value ?? ''}
                    // onChange={(e) => onChange?.(e.target.value)}
                    onChange={onChange}
                >
                    <MenuItem disabled value={value}>{value}</MenuItem>
                    {options.map((opt) => (
                        <MenuItem key={opt._id} value={(nameInput === 'provinciaId' || nameInput === 'tipoId' || nameInput === 'categoriaId') ? opt._id : opt.designacao}>
                            {opt.designacao}
                        </MenuItem>
                    ))}
                </TextField>
            );
        }

        return (
            <TextField
                size="small"
                fullWidth
                type={type}
                defaultValue={value ?? ''}
                // onChange={(e) => onChange?.(e.target.value)}
                onChange={onChange}
                InputLabelProps={type === 'date' ? { shrink: true } : undefined}
            />
        );
    };


    return (
        <Grid item xs={xs} sm={sm} >
            <Box>
                <Typography variant={variant ?? 'caption'} color="text.secondary">
                    {label}
                </Typography>

                {!editable ? (
                    <Tooltip title={renderValue() || ''} >
                        <Typography
                            variant="body1"
                            sx={{
                                // whiteSpace: 'nowrap',
                                overflow: 'auto',
                                // textOverflow: 'ellipsis',
                                cursor: 'default',
                            }}
                        >
                            {renderValue()}
                        </Typography>
                    </Tooltip>
                ) : (
                    renderInput()
                )}
            </Box>
        </Grid>
    );
};

export default InfoField; 
